import { PaymentMethod } from '../../core/reducers/financialCalculators';
// eslint-disable-next-line import/prefer-default-export
export const paymentTabs = [
    { method: PaymentMethod.lease, label: 'Shared.Common.leaseMethodLabel' },
    { method: PaymentMethod.finance, label: 'Shared.Common.financeMethodLabel' },
    { method: PaymentMethod.cash, label: 'Shared.Common.cashMethodLabel' },
];
